module.exports = __webpack_public_path__ + "static/media/intro.084cf27.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/intro.mp4
// module id = SvDD
// module chunks = 1